!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@hotmart/cosmos"] = t() : e["@hotmart/cosmos"] = t();
}(self, function () {
  return (() => {
    "use strict";

    var e = {
        7705: e => {
          e.exports = function (e) {
            var t = [];
            return t.toString = function () {
              return this.map(function (t) {
                var i = "",
                  o = void 0 !== t[5];
                return t[4] && (i += "@supports (".concat(t[4], ") {")), t[2] && (i += "@media ".concat(t[2], " {")), o && (i += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), i += e(t), o && (i += "}"), t[2] && (i += "}"), t[4] && (i += "}"), i;
              }).join("");
            }, t.i = function (e, i, o, r, n) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var a = {};
              if (o) for (var s = 0; s < this.length; s++) {
                var c = this[s][0];
                null != c && (a[c] = !0);
              }
              for (var l = 0; l < e.length; l++) {
                var m = [].concat(e[l]);
                o && a[m[0]] || (void 0 !== n && (void 0 === m[5] || (m[1] = "@layer".concat(m[5].length > 0 ? " ".concat(m[5]) : "", " {").concat(m[1], "}")), m[5] = n), i && (m[2] ? (m[1] = "@media ".concat(m[2], " {").concat(m[1], "}"), m[2] = i) : m[2] = i), r && (m[4] ? (m[1] = "@supports (".concat(m[4], ") {").concat(m[1], "}"), m[4] = r) : m[4] = "".concat(r)), t.push(m));
              }
            }, t;
          };
        },
        6742: e => {
          e.exports = function (e, t) {
            return t || (t = {}), e ? (e = String(e.__esModule ? e.default : e), /^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), t.hash && (e += t.hash), /["'() \t\n]|(%20)/.test(e) || t.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e) : e;
          };
        },
        6738: e => {
          e.exports = function (e) {
            return e[1];
          };
        },
        4675: (e, t, i) => {
          i.d(t, {
            Z: () => g
          });
          var o = i(6738),
            r = i.n(o),
            n = i(7705),
            a = i.n(n),
            s = i(6742),
            c = i.n(s),
            l = new URL(i(4742), i.b),
            m = a()(r()),
            b = c()(l);
          m.push([e.id, ":host{border:var(--collapse-border, none)}:host .hot-collapse__item{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--collapse-item-bg, transparent);border:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;color:var(--gray-700, #32363b);cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-weight:var(--font-weight, 400);-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0;-webkit-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-moz-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-moz-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1))}:host .hot-collapse__item:hover{background-color:var(--gray-100, #f7f9fa)}:host .hot-collapse__item:hover,:host .hot-collapse__item:focus{text-decoration:none}:host .hot-collapse__item--collapsed{border:0;-webkit-transition:height var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:height var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:height var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:height var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1))}:host .hot-collapse__item .hot-collapse__arrow{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-image:url(" + b + ");background-position:center center;-moz-background-size:100% auto;background-size:100% auto;cursor:pointer;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:var(--text-1, 0.75rem);line-height:var(--line-height-lg, 1.5);margin-right:var(--collapse-arrow-margin, 1rem);opacity:var(--collapse-arrow-opacity, 1);text-decoration:none;-webkit-transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)) -webkit-calc(var(--timing, 500ms)/1.5),-webkit-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)) calc(var(--timing, 500ms)/1.5),-webkit-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)) calc(var(--timing, 500ms)/1.5),-o-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)) -moz-calc(var(--timing, 500ms)/1.5),transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-moz-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)) calc(var(--timing, 500ms)/1.5),transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:opacity var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)) calc(var(--timing, 500ms)/1.5),transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-moz-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-o-transform var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));width:var(--text-1, 0.75rem)}@media screen and (prefers-reduced-motion: reduce){:host .hot-collapse__item .hot-collapse__arrow{-webkit-transition:none;-o-transition:none;-moz-transition:none;transition:none}}:host .hot-collapse__item .hot-collapse__title{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;padding:var(--collapse-padding, 0.5rem 1rem)}:host(.hot-collapse--disabled) .hot-collapse__arrow,:host([disabled]) .hot-collapse__arrow{display:none}:host(.hot-collapse--active) .hot-collapse__arrow,:host([active]) .hot-collapse__arrow{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}:host([active]) .hot-collapse__item--collapsed{overflow:hidden}:host(.hot-collapse--arrow-start) .hot-collapse__item{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-moz-box-orient:horizontal;-moz-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.hot-collapse--arrow-start) .hot-collapse__item .hot-collapse__arrow{margin-left:var(--collapse-arrow-margin, 1rem);margin-right:0}", ""]);
          const g = m;
        },
        5097: (e, t, i) => {
          i.d(t, {
            Z: () => s
          });
          var o = i(6738),
            r = i.n(o),
            n = i(7705),
            a = i.n(n)()(r());
          a.push([e.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
          const s = a;
        },
        4742: e => {
          e.exports = "data:image/svg+xml,%3Csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 448 512%27%3E%3Cpath fill=%27%23545b64000000%27 d=%27M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z%27/%3E%3C/svg%3E";
        }
      },
      t = {};
    function i(o) {
      var r = t[o];
      if (void 0 !== r) return r.exports;
      var n = t[o] = {
        id: o,
        exports: {}
      };
      return e[o](n, n.exports, i), n.exports;
    }
    i.m = e, i.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return i.d(t, {
        a: t
      }), t;
    }, i.d = (e, t) => {
      for (var o in t) i.o(t, o) && !i.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    }, i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), i.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, i.b = document.baseURI || self.location.href;
    var o = {};
    return (() => {
      i.r(o);
      const e = require("@babel/runtime/helpers/classCallCheck");
      var t = i.n(e);
      const r = require("@babel/runtime/helpers/createClass");
      var n = i.n(r);
      const a = require("@babel/runtime/helpers/assertThisInitialized");
      var s = i.n(a);
      const c = require("@babel/runtime/helpers/get");
      var l = i.n(c);
      const m = require("@babel/runtime/helpers/inherits");
      var b = i.n(m);
      const g = require("@babel/runtime/helpers/possibleConstructorReturn");
      var u = i.n(g);
      const v = require("@babel/runtime/helpers/getPrototypeOf");
      var h = i.n(v);
      const d = require("@babel/runtime/helpers/wrapNativeSuper");
      var p = i.n(d),
        f = i(5097);
      var _ = function (e) {
        b()(a, e);
        var i,
          o,
          r = (i = a, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = h()(i);
            if (o) {
              var r = h()(this).constructor;
              e = Reflect.construct(t, arguments, r);
            } else e = t.apply(this, arguments);
            return u()(this, e);
          });
        function a(e) {
          var i;
          t()(this, a);
          var o = (i = r.call(this)).getTemplate(),
            n = document.createElement("template");
          n.innerHTML = o;
          var s = n.content.querySelector("style");
          return s && (s.innerHTML = "".concat(s.innerHTML, " ").concat(f.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(n, e), i.attachShadow({
            mode: "open"
          }), i.shadowRoot.appendChild(document.importNode(n.content, !0)), i;
        }
        return n()(a, [{
          key: "connectedCallback",
          value: function () {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "";
          }
        }]), a;
      }(p()(HTMLElement));
      const w = _;
      var y,
        z,
        x = "hot-collapse",
        k = "active",
        E = "disabled",
        S = i(4675);
      y = x, z = function (e) {
        b()(a, e);
        var i,
          o,
          r = (i = a, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = h()(i);
            if (o) {
              var r = h()(this).constructor;
              e = Reflect.construct(t, arguments, r);
            } else e = t.apply(this, arguments);
            return u()(this, e);
          });
        function a() {
          var e;
          return t()(this, a), (e = r.call(this, x))._collapseHeader = e.shadowRoot.querySelector(".hot-collapse__item"), e._collapsedSlot = e.shadowRoot.querySelector('slot[name="collapsed"]'), e._onAnimationEnd = e._onAnimationEnd.bind(s()(e)), e._toggleCollapse = e._toggleCollapse.bind(s()(e)), e._onToggleCollapse = e._onToggleCollapse.bind(s()(e)), e;
        }
        return n()(a, [{
          key: "attributeChangedCallback",
          value: function () {
            this._toggleCollapse();
          }
        }, {
          key: "connectedCallback",
          value: function () {
            l()(h()(a.prototype), "connectedCallback", this).call(this), this._collapseHeader.addEventListener("click", this._onToggleCollapse), this._collapsedSlot.addEventListener("slotchange", this._toggleCollapse), this._toggleCollapse();
          }
        }, {
          key: "disconnectedCallback",
          value: function () {
            this._collapseHeader.removeEventListener("click", this._onToggleCollapse), this._collapsedSlot.removeEventListener("slotchange", this._toggleCollapse);
          }
        }, {
          key: "_onToggleCollapse",
          value: function () {
            this.hasAttribute(k) ? this.removeAttribute(k) : this.setAttribute(k, "");
          }
        }, {
          key: "_toggleCollapse",
          value: function () {
            var e = this.hasAttribute(k),
              t = this.hasAttribute(E),
              i = this.shadowRoot.querySelector(".hot-collapse__item--collapsed");
            e || t ? (this._toggleAnimationEvent("addEventListener", this._onAnimationEnd), i.style.height = "".concat(i.scrollHeight, "px")) : (this._toggleAnimationEvent("addEventListener", this._onAnimationEnd), i.style.overflow = "hidden", i.style.height = "".concat(i.scrollHeight, "px"), i.scrollHeight, i.style.height = 0);
          }
        }, {
          key: "_toggleAnimationEvent",
          value: function (e) {
            var t = this.shadowRoot.querySelector(".hot-collapse__item--collapsed");
            t[e]("webkitTransitionEnd", this._onAnimationEnd), t[e]("oTransitionEnd", this._onAnimationEnd), t[e]("msAnimationEnd", this._onAnimationEnd), t[e]("transitionend", this._onAnimationEnd);
          }
        }, {
          key: "_onAnimationEnd",
          value: function () {
            var e = this.hasAttribute(k),
              t = this.shadowRoot.querySelector(".hot-collapse__item--collapsed");
            this._toggleAnimationEvent("removeEventListener", this._onAnimationEnd), e ? (t.style.overflow = "visible", t.style.height = "auto", this.dispatchEvent(new CustomEvent("open"))) : this.dispatchEvent(new CustomEvent("close"));
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <style>".concat(S.Z.toString(), '</style>\n      <div class="hot-collapse__item">\n        <div class="hot-collapse__title">\n          <slot></slot>\n        </div>\n        <div class="hot-collapse__arrow"></div>\n      </div>\n      <div class="hot-collapse__item--collapsed">\n        <slot name="collapsed"></slot>\n      </div>\n    ');
          }
        }], [{
          key: "observedAttributes",
          get: function () {
            return [k, E];
          }
        }]), a;
      }(w), customElements.get(y) || customElements.define(y, z);
    })(), o;
  })();
});